// @flow
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import './Results.scss';

type Props = {
  totalResults: number,
  selectedResults: number,
  isLoading: boolean,
};
/**
 * Displays results for filtering products
 */

const ResultsComponent = (props: Props) => {
  const getNumberOfItems = ({ isLoading, selectedResults, totalResults }) => {
    if (isLoading) {
      return '';
    }
    if (selectedResults === undefined) {
      return totalResults;
    }
    if (selectedResults < totalResults || totalResults < 2) {
      return selectedResults;
    }

    return (
      <FormattedMessage
        id="app.products.selected.selectedProductsNumber"
        defaultMessage="All {totalProducts}"
        values={{ totalProducts: totalResults }}
      />
    );
  };

  const getSelectedItemsText = ({ isLoading, selectedResults }) => {
    if (isLoading) {
      return '';
    }
    if (selectedResults === undefined) {
      return <FormattedMessage id="app.products.selected.results" defaultMessage="results" />;
    }

    return (
      <FormattedMessage
        id="app.products.selected.selectedProductsText"
        defaultMessage="{selectedProducts, plural, one {item is selected} other {items are selected}}"
        values={{ selectedProducts: selectedResults }}
      />
    );
  };

  return (
    <div className="results-component">
      <span className="results-component__items u-fontFamily-primaryMedium">{getNumberOfItems(props)}</span>{' '}
      <span className="results-component__text u-fontFamily-secondary">{getSelectedItemsText(props)}</span>
    </div>
  );
};

ResultsComponent.displayName = 'Results';

ResultsComponent.propTypes = {
  totalResults: PropTypes.number.isRequired,
  selectedResults: PropTypes.number,
  isLoading: PropTypes.bool,
};

export default ResultsComponent;
